<template>
    <div class="design-4 floor-wsw floor-style-6 floors_border floor-bgImg-box" :id="data.block_name+c_index">
        <floorHeader :info="data"></floorHeader>
        <div class="goods-list">
            <template v-for="(item, index) in data.value.goodsList.value.list">
                <template v-if="index <= 9">
                    <div class="hoverBox hoverBoder">
                        <goodsListItem :goods="item" :upDownLayout="true"></goodsListItem>
                    </div>
                </template>
            </template>
        </div>
        <floorBgImg :info="data"></floorBgImg>
    </div>
</template>

<script>
import ctrlShowText from "@/components/ctrl-show-text/ctrl-show-text.vue";
import GoodsListItem from "@/components/goods-list-item/goods-list-item.vue";
import goodsPrice from '@/components/goods-price/goods-price.vue';
import shareCounter from "@/components/shareCounter.vue";
import { onTip } from "@/utils/tips";
import { mapGetters } from "vuex";
import floorHeader from "./floor-header.vue";
import floorBgImg from "./floor-bgImg.vue";
export default {
    name: "floor-style-ermei-design-4",
    components: {
        shareCounter,
        ctrlShowText,
        goodsPrice,
        GoodsListItem,
        floorHeader,
        floorBgImg
    },
    props: {
        data: {
            type: Object
        },
        c_index:{
            type: Number
        }
    },
    data() {
        return {
            number: 1
        }
    },
    computed: {
        ...mapGetters(["member", "token"])
    },
    methods: {
        upnumber(val) {
            this.number = val
        },
        goSku(item) {
            if (!this.$store.getters.token) {
                this.$router.pushToTab("/login")
                return
            }
            if (onTip(item.sale_control.view_price,item.sale_control.is_member_by,this,item.sale_control.not_buy_msg)) return
            this.$router.pushToTab("/sku-" + item.sku_id)
        },
        // 加入购物车
        joinCart(item,index) {
            if (onTip(item.sale_control?.view_price,item.sale_control?.is_member_by,this,item.sale_control?.not_buy_msg)) return
            this.$store
                .dispatch("cart/add_to_cart", {
                    site_id: item.site_id,
                    sku_id: item.sku_id,
                    num: this.number
                })
                .then(res => {
                    if (res.code === 0) {
                        this.$message({
                            message: "加入购物车成功",
                            type: "success"
                        })
                    }
                })
                .catch(err => {
                    if (err.message === "token不存在") {
                        this.$router.pushToTab("/login")
                    } else {
                        this.$message.error(err.message);
                        if(typeof err.data === 'number'){
                            if(err.data > 0){
                                this.$refs['shareCounter'+index][0].upnumber(err.data);
                                this.$message({
                                    message: "当前数量已更改为可购买数量，请重试加入购物车",
                                    type: "success"
                                });
                            }else{
                                window.location.reload();
                            }
                        }
                    }
                })
        }
    },
    computed: {
        ...mapGetters(["defaultGoodsImage", "cartCount", "siteInfo", "member"]),
        logined: function() {
            return this.member !== undefined && this.member !== "" && this.member != {}
        }
    }
}
</script>

<style lang="scss" scoped>
.design-4 {
    margin-top: 20px;
    background: #fff;
    box-sizing: border-box;
    .goods-list{
        position: relative;
        z-index: 2;
    }
    .goods-list {
        display: flex;
        gap: 12px;
        flex-wrap: wrap;
        padding: 12px;
        box-sizing: border-box;
        >div{
            width: calc((100% - 48px) / 5);
            border: 1px solid #f9f9f9;
            box-sizing: border-box;
            border-radius: 12px;
            box-sizing: border-box;
            padding: 12px;
            transition: all 0.2s linear;
            background-color: #fff;
            &:hover {
                z-index: 2;
                -webkit-box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
                box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
                -webkit-transform: translate3d(0, -2px, 0);
                transform: translate3d(0, -2px, 0);
            }
        }
    }
}
</style>
